import myaxios from "../../components/Axios";

export const getSingleContactService = ({ id, expand = '' }: { id: number, expand: string }) => myaxios.get(`/ajax/contact/${id}?expand=${expand}`)
export const getContactListService = ({ link = "" }) => myaxios.get(`/ajax/contact${link}`)
export const createContactService = ({ data }: { data: any }) => myaxios.post(`/ajax/contact`, data)
export const updateContactService = ({ id, data }: { id: number, data: any }) => myaxios.put(`/ajax/contact/${id}`, data)
export const deleteContactService = ({ id }: { id: number }) => myaxios.delete(`/ajax/contact/${id}`)